import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    setTimeout(() => {
      this.element.remove();
    }, 100000); // Adjust the time as needed

    if (this.element.innerHTML.trim().length > 0) {
      this.element.scrollIntoView({ behavior: "smooth", block: "start" })
    }
  }
}